var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 2C5.05228 2 5.5 2.44772 5.5 3V10C5.5 10.5523 5.05228 11 4.5 11C3.94772 11 3.5 10.5523 3.5 10V3C3.5 2.44772 3.94772 2 4.5 2ZM12.5 2C13.0523 2 13.5 2.44772 13.5 3V7H15.5C16.0523 7 16.5 7.44772 16.5 8C16.5 8.55228 16.0523 9 15.5 9H9.5C8.94772 9 8.5 8.55228 8.5 8C8.5 7.44772 8.94772 7 9.5 7H11.5V3C11.5 2.44772 11.9477 2 12.5 2ZM20.5 2C21.0523 2 21.5 2.44772 21.5 3V12C21.5 12.5523 21.0523 13 20.5 13C19.9477 13 19.5 12.5523 19.5 12V3C19.5 2.44772 19.9477 2 20.5 2ZM12.5 11C13.0523 11 13.5 11.4477 13.5 12V21C13.5 21.5523 13.0523 22 12.5 22C11.9477 22 11.5 21.5523 11.5 21V12C11.5 11.4477 11.9477 11 12.5 11ZM0.5 14C0.5 13.4477 0.947715 13 1.5 13H7.5C8.05228 13 8.5 13.4477 8.5 14C8.5 14.5523 8.05228 15 7.5 15H5.5V21C5.5 21.5523 5.05228 22 4.5 22C3.94772 22 3.5 21.5523 3.5 21V15H1.5C0.947715 15 0.5 14.5523 0.5 14ZM16.5 16C16.5 15.4477 16.9477 15 17.5 15H23.5C24.0523 15 24.5 15.4477 24.5 16C24.5 16.5523 24.0523 17 23.5 17H21.5V21C21.5 21.5523 21.0523 22 20.5 22C19.9477 22 19.5 21.5523 19.5 21V17H17.5C16.9477 17 16.5 16.5523 16.5 16Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilters);
export default __webpack_public_path__ + "static/media/filters.3df487fb0dc571cdf05aa7bacf6c4718.svg";
export { ForwardRef as ReactComponent };